<template>
  <div id="bgContainer" class="app-list-container" :style="styleObject">

    <div class="app-list-wrapper glass scale-in">
      <!-- 应用列表区域 -->
      <div class="app-content">
        <el-tabs
          :stretch="true"
          v-model="activeName"
          @tab-click="handleClick"
          class="app-tabs">

          <el-tab-pane
            class="app-tab-pane"
            v-for="(item,index) in dataList"
            :key="index"
            :label="item.name"
            :name="item.name">

            <!-- 应用卡片网格 -->
            <div class="app-grid">
              <div
                class="app-card hover-card"
                @click="getSubAppCallback(i)"
                v-for="(i,index2) in item.appList"
                :key="index2">
                <div class="app-icon-wrapper">
                  <el-image
                    class="app-icon"
                    :src="i.icon_url"
                    fit="contain">
                    <div slot="error" class="icon-error">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div class="app-icon-glow"></div>
                </div>
                <span class="app-name">{{ i.name }}</span>
              </div>
            </div>

          </el-tab-pane>

        </el-tabs>
      </div>

      <!-- 分割线 -->
      <div class="divider"></div>

      <!-- 用户信息区域 -->
      <div class="user-info-panel">
        <div class="user-info-header">
          <div class="user-title">个人信息</div>
        </div>

        <div class="user-info-content">
          <div class="info-item" v-if="userInfo.school.name !== undefined && userInfo.school.name !== null">
            <div class="info-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="info-content">
              <div class="info-label">姓名</div>
              <div class="info-value">{{ userInfo.school.name || '暂无' }}</div>
            </div>
          </div>

          <div class="info-item" v-if="userInfo.school.type !== undefined">
            <div class="info-icon">
              <i class="el-icon-collection-tag"></i>
            </div>
            <div class="info-content">
              <div class="info-label">人员类型</div>
              <div class="info-value">{{ userInfo.school.type.info || '暂无' }}</div>
            </div>
          </div>

          <div class="info-item" v-if="userInfo.app_user.user_phone !== undefined">
            <div class="info-icon">
              <i class="el-icon-phone-outline"></i>
            </div>
            <div class="info-content">
              <div class="info-label">手机号码</div>
              <div class="info-value">{{ userInfo.app_user.user_phone || '暂无' }}</div>
            </div>
          </div>

          <div class="info-item" v-if="userInfo.school.card_number !== undefined">
            <div class="info-icon">
              <i class="el-icon-bank-card"></i>
            </div>
            <div class="info-content">
              <div class="info-label">校园卡号</div>
              <div class="info-value">{{ userInfo.school.card_number || '暂无' }}</div>
            </div>
          </div>

          <div class="info-item" v-if="userInfo.school.id_card !== undefined">
            <div class="info-icon">
              <i class="el-icon-postcard"></i>
            </div>
            <div class="info-content">
              <div class="info-label">身份证号</div>
              <div class="info-value">{{ userInfo.school.id_card || '暂无' }}</div>
            </div>
          </div>
        </div>

        <el-button type="danger" class="logout-button" @click="logout">
          <i class="el-icon-switch-button"></i>
          <span>退出登录</span>
        </el-button>
      </div>
    </div>

  </div>
</template>

<script>
import * as clientUtils from "@/axios/ClientUtils";
import {AestheticFluidBg} from './build/jsm/AestheticFluidBg.module.js'

export default {
  name: "AppList",
  data() {
    return {
      // 用户详细信息
      userInfo: {},
      //筛选之后的数据源
      dataList: [],
      activeName: '迎新专栏',
      app_id: '',

      //动态style背景色
      styleObject: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        backgroundImage: '',
        backgroundSize: 'cover'
      }
    }
  },
  mounted() {

    this.app_id = localStorage.getItem('app_id')
    if (parseInt(this.app_id) === 1) {
      this.styleObject.backgroundImage = 'url("https://moyo-web-v2-prod.bj.bcebos.com/%E6%A0%A1%E5%9B%AD%E9%A3%8E%E5%85%89/01.jpg")'
    } else if (parseInt(this.app_id) === 2) {
      this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/dhd/background/web/bg.jpg")'
    } else if (parseInt(this.app_id) === 3) {
      this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/lnzy/background/web/bg.jpg")'
    } else if (parseInt(this.app_id) === 4) {
      this.styleObject.backgroundImage = 'url("https://www.lnxdfwxy.com/__local/3/0D/89/DA8EA5534105C71C7C2E466985D_FD86E4A6_96C85.png?e=.png")'
    } else if (parseInt(this.app_id) === 5) {
      this.styleObject.backgroundImage = 'url("https://moyo-web-v2-prod.bj.bcebos.com/talk/20160104095919330750.jpg")'
    } else if (parseInt(this.app_id) === 6) {
      this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/dhd/background/web/bg.jpg")'
    } else if (parseInt(this.app_id) === 7) {
      setTimeout(function () {
        new AestheticFluidBg({
          dom: "bgContainer",
          colors: ["#007FFE", "#3099FE", "#60B2FE", "#90CCFE", "#C0E5FE", "#F0FFFE"],
          seed: 1000,
          loop: true
        })
      }, 200)

    }

    this.getUserInfo()

  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },

    //退出登录事件
    logout() {
      localStorage.setItem("token", '')
      this.$router.replace("userLoginPC")
    },

    //获取全部应用数据
    getMenu() {
      const that = this
      clientUtils.get("/autoLogin/v2/pri/app/show/menu", function (res) {
        console.log(res)
        let initList = res.data.data.sub_app_list
        let menuList = res.data.data.menu_config

        let psList = []

        // 开始剔除不该显示的app对象，遍历menulist
        for (let i = 0; i < menuList.length; i++) {
          // 遍历menu中每一项的subapp，判断hide值
          for (let j = 0; j < menuList[i].sub_apps.length; j++) {


            // 排除hide，是否隐藏字段
            if (menuList[i].sub_apps[j].hide === false && menuList[i].sub_apps[j].only_mini_app !== true) {

              for (let k = 0; k < initList.length; k++) {

                if (initList[k].id === menuList[i].sub_apps[j].id) {
                  // 匹配到该app后首先判断认证字段是否为true，人员的认证字段是否为true，并且app的认证字段不得为undifined
                  //符合的情况下就要去匹配type，xy，zy，此时schoolID和userID不存在不需要判断
                  if (initList[k].view_rules.need_identity === true && that
                      .userInfo
                      .bind_school_identity === true && initList[k].view_rules
                      .need_identity !== undefined) {

                    if (initList[k].view_rules.need_identity === true && that
                        .userInfo.bind_school_identity === true) {
                      // 首先判断schoolids存在不存在
                      if (initList[k].view_rules.school_ids !== undefined) {
                        initList[k].view_rules.school_ids.map((item) => {
                          console.log(initList[k])
                          console.log(item + ' ' + that.userInfo
                              .school.school_id)
                          if (item === that.userInfo.school
                              .school_id) {
                            psList.push(initList[k])
                            console.log("推入成功")
                          }
                        })
                      }
                    }


                    // 只有认证信息匹配，其他的条件都没有
                    if ((initList[k].view_rules.need_identity && that.userInfo
                            .bind_school_identity) && initList[k].view_rules
                            .type === undefined && initList[k].view_rules.xy ===
                        undefined && initList[k].view_rules.zy === undefined &&
                        initList[k].view_rules.school_ids === undefined &&
                        initList[k].view_rules.app_user_ids === undefined) {
                      psList.push(initList[k])
                    }


                    //type不为空并且跟用户信息匹配
                    if (initList[k].view_rules.type !== undefined && that
                        .userInfo.school.type.value === initList[k].view_rules
                        .type) {
                      //学院信息不为空并跟用户匹配
                      if (initList[k].view_rules.xy !== undefined && that
                          .userInfo.school.xy === initList[k].view_rules.xy
                      ) {
                        //专业信息不为空并跟用户匹配
                        if (initList[k].view_rules.zy !== undefined && that
                            .userInfo.school.zy === initList[k].view_rules
                            .zy) {

                          if (initList[k].view_rules.need_identity ===
                              this.userInfo.bind_school_identity) {
                            psList.push(initList[k])
                          }

                          //学院信息匹配 专业信息不存在
                        } else if (initList[k].view_rules.zy ===
                            undefined) {
                          if (initList[k].view_rules.need_identity ===
                              that.userInfo.bind_school_identity) {
                            psList.push(initList[k])
                          }
                        }
                        //专业信息匹配，并不存在xy信息的情况（没有xy一定没有zy）
                      } else if (initList[k].view_rules.xy === undefined) {
                        if (initList[k].view_rules.need_identity === that
                            .userInfo.bind_school_identity) {
                          psList.push(initList[k])
                        }
                      }
                      //type为空并且学院不为空
                    } else if (initList[k].view_rules.type === undefined &&
                        initList[k].view_rules.xy !== undefined && initList[k]
                            .view_rules.xy === that.userInfo.school.xy) {
                      //专业信息不为空并跟用户匹配
                      if (initList[k].view_rules.zy !== undefined && that
                          .userInfo.school.zy === initList[k].view_rules.zy
                      ) {
                        if (initList[k].view_rules.need_identity === that
                            .userInfo.bind_school_identity) {
                          psList.push(initList[k])
                        }
                        //学院信息匹配 专业信息不存在
                      } else if (initList[k].view_rules.zy === undefined) {
                        if (initList[k].view_rules.need_identity === that
                            .userInfo.bind_school_identity) {
                          psList.push(initList[k])
                        }
                      }
                    }


                  } else if (initList[k].view_rules.need_identity ===
                      undefined || initList[k].view_rules.need_identity === false
                  ) {
                    // 此处代表这个应用不需要认证,但是需要检查该用户id在不在schoolID/userID集合中
                    console.log(initList[k].name)
                    if (initList[k].view_rules.app_user_ids !==
                        undefined) {
                      initList[k].view_rules.app_user_ids.map((item) => {
                        console.log(item + ' ' + that.userInfo
                            .app_user.app_user_id)
                        if (item === that.userInfo.app_user
                            .app_user_id) {
                          psList.push(initList[k])
                          console.log(initList[k].name)
                        }
                      })
                      //此时代表userids和schoolids都为空
                    } else if (initList[k].view_rules.app_user_ids ===
                        undefined && initList[k].view_rules.school_ids ===
                        undefined) {
                      psList.push(initList[k])
                    }

                  } else if (initList[k].view_rules.need_identity && !that
                      .userInfo.bind_school_identity && initList[k].view_rules
                      .need_identity !== undefined) {
                    // 此时代表该应用需要认证，但用户并未完成认证，则该app不显示，直接break出去

                  }
                } //第三层里第一个if，判断id是否相等的那个

              } //第三层花括号 k
            } //判断hide的那个花扣号
            else {
              console.log(menuList[i].sub_apps[j].hide + "" + menuList[i].sub_apps[j]
                  .id)
            }

          } //第二层for 循环花括号 j
        } //最外层for循环花括号 i

        // 此时初步筛选appLits成功，开始组装最后的数据源
        let resultList = []
        for (let i = 0; i < menuList.length; i++) {
          resultList.push({
            name: menuList[i].name,
            appList: []
          })
          for (let j = 0; j < menuList[i].sub_apps.length; j++) {
            psList.map((item) => {
              if (menuList[i].sub_apps[j].hide === false) {
                if (item.id === menuList[i].sub_apps[j].id) {
                  let obj = item
                  obj.order = menuList[i].sub_apps[j].order
                  resultList[i].appList.push(obj)
                }
              }
            })
          }
        }

        resultList = resultList.filter(item => item.appList.length > 0);


        // 开始数组去重
        for (let i = 0; i < resultList.length; i++) {
          for (let j = 0; j < resultList[i].appList.length; j++) {
            for (let k = j + 1; k < resultList[i].appList.length; k++) {
              if (resultList[i].appList[j] === resultList[i].appList[
                  k]) { //第一个等同于第二个，splice方法删除第二个
                resultList[i].appList.splice(k, 1);
                k--;
              }
            }
          }
        }

        for (let i = 0; i < resultList.length; i++) {
          resultList[i].appList.sort(function (a, b) {
            return a.order - b.order
          })
        }

        console.log('最终resultList')
        console.log(resultList)
        that.dataList = resultList
        that.activeName = resultList[0].name
      })

    },


    //点击子应用时调用该方法，获取子应用回调地址等信息
    getSubAppCallback(item) {
      console.log(item)

      const tokenUserInfo = localStorage.getItem('token')
      const appIdUserInfo = localStorage.getItem('app_id')
      var myHeaders = new Headers();
      myHeaders.append("app-id", appIdUserInfo);
      myHeaders.append("sub-app-id", item.id);
      myHeaders.append("access-token", tokenUserInfo);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch("https://loginv2.timkj.cn/autoLogin/v2/pri/app/get/subAppCallback", requestOptions)
          .then(response => response.json())
          .then(function (res) {
            console.log(res)
            let baseurl
            if (res.data.address.indexOf("?") !== -1) {
              baseurl = res.data.address + "&access_token=" + tokenUserInfo +
                  '&app_id=' +
                  appIdUserInfo +
                  '&sub_app_id=' + item.id + "&config="
            } else {
              baseurl = res.data.address + "?access_token=" + tokenUserInfo +
                  '&app_id=' +
                  appIdUserInfo +
                  '&sub_app_id=' + item.id + "&config="
            }

            console.log(baseurl)
            window.open(baseurl, 'target');


          })
          .catch(error => console.log('error', error));


    },

    //获取用户详细信息
    getUserInfo() {
      const that = this
      clientUtils.get("/autoLogin/v2/pri/user/get/userInfo", function (res) {

        //获取用户信息成功 调用获取应用列表接口getMenu
        if (res.data.code === 0) {
          console.log(res.data.data)
          that.userInfo = res.data.data
          that.getMenu()
        } else {
          //失败通知及跳转userLoginPC
          that.$notify.error({
            title: '获取用户信息失败',
            message: res.data.msg + res.data.data
          });
          that.$router.replace('userLogInPC')
        }

      })
    }


  }
}
</script>

<style scoped lang="scss">
// 应用列表容器
.app-list-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(2px);
    z-index: 1;
  }
}

// 应用列表包装器
.app-list-wrapper {
  position: relative;
  z-index: 10;
  width: 85%;
  max-width: 1400px;
  min-height: 600px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  display: flex;
  flex-direction: row;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.5);
  overflow: hidden;
}

// 应用内容区域
.app-content {
  flex: 1;
  padding: 30px 40px;
  min-height: 600px;
}

// 标签页样式
.app-tabs {
  ::v-deep .el-tabs__header {
    margin: 0 0 30px 0;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background: linear-gradient(90deg, transparent 0%, #e4e7ed 50%, transparent 100%);
  }

  ::v-deep .el-tabs__item {
    font-size: 18px;
    font-weight: 500;
    color: #606266;
    padding: 0 24px;
    height: 50px;
    line-height: 50px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      color: #586cb1;
    }

    &.is-active {
      color: #586cb1;
      font-weight: 600;
    }
  }

  ::v-deep .el-tabs__active-bar {
    background: linear-gradient(90deg, #586cb1, #7a8bc9, #586cb1);
    height: 3px;
    border-radius: 2px 2px 0 0;
  }
}

// 应用标签面板
.app-tab-pane {
  min-height: 450px;
}

// 应用网格
.app-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 24px;
  padding: 10px;
}

// 应用卡片
.app-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 12px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #ebeef5;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(88, 108, 177, 0.05) 0%, rgba(88, 108, 177, 0.02) 100%);
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(88, 108, 177, 0.2);
    border-color: rgba(88, 108, 177, 0.3);

    &::before {
      opacity: 1;
    }

    .app-icon-wrapper {
      transform: scale(1.1) rotate(5deg);
    }

    .app-name {
      color: #586cb1;
      font-weight: 600;
    }

    .app-icon-glow {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-3px);
  }
}

// 应用图标包装器
.app-icon-wrapper {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
}

// 应用图标
.app-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  transition: all 0.3s;
  object-fit: contain;
}

.icon-error {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #c0c4cc;
  font-size: 30px;
  border-radius: 12px;
}

// 应用图标发光效果
.app-icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110px;
  height: 110px;
  background: radial-gradient(circle, rgba(88, 108, 177, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
}

// 应用名称
.app-name {
  margin-top: 14px;
  font-size: 14px;
  color: #303133;
  text-align: center;
  line-height: 1.5;
  transition: all 0.3s;
  position: relative;
  z-index: 2;
  max-width: 100%;
  padding: 0 4px;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

// 分割线
.divider {
  width: 1px;
  height: 80%;
  background: linear-gradient(180deg, transparent 0%, #e4e7ed 20%, #e4e7ed 80%, transparent 100%);
  margin: auto 0;
}

// 用户信息面板
.user-info-panel {
  width: 320px;
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #fafbfc 0%, #f5f7fa 100%);
}

// 用户信息头部
.user-info-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.user-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

// 用户信息内容
.user-info-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 30px;
}

// 信息项
.info-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 4px 12px rgba(88, 108, 177, 0.1);
    transform: translateX(4px);
  }
}

.info-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(88, 108, 177, 0.1) 0%, rgba(88, 108, 177, 0.05) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #586cb1;
  font-size: 18px;
  flex-shrink: 0;
}

.info-content {
  flex: 1;
  min-width: 0;
}

.info-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.info-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 退出登录按钮
.logout-button {
  width: 100%;
  height: 48px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  background: linear-gradient(135deg, #f56c6c 0%, #dd6161 100%);
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: linear-gradient(135deg, #f78989 0%, #f56c6c 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(245, 108, 108, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
}

// 动画
@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.scale-in {
  animation: scaleIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

// 玻璃态效果
.glass {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.6);
}

// 响应式设计
@media (max-width: 1200px) {
  .app-list-wrapper {
    width: 95%;
    flex-direction: column;
  }

  .divider {
    width: 80%;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, #e4e7ed 50%, transparent 100%);
    margin: 20px auto;
  }

  .user-info-panel {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 20px;
  }

  .user-info-header {
    width: 100%;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }

  .user-info-content {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
  }

  .info-item {
    flex: 1 1 calc(50% - 6px);
    min-width: 200px;
  }

  .logout-button {
    width: auto;
    min-width: 150px;
  }
}

@media (max-width: 768px) {
  .app-list-wrapper {
    width: 98%;
    min-height: auto;
  }

  .app-content {
    padding: 20px;
  }

  .app-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 16px;
  }

  .app-card {
    padding: 16px 8px;
  }

  .app-icon-wrapper {
    width: 80px;
    height: 80px;
  }

  .app-icon {
    width: 56px;
    height: 56px;
  }

  .app-name {
    font-size: 12px;
    margin-top: 10px;
  }

  .user-info-panel {
    padding: 16px;
  }

  .info-item {
    flex: 1 1 100%;
  }
}
</style>
